import useSWR, { type SWRConfiguration } from "swr";
import type { SamplesGeoJsonResponse } from "./type";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import { config } from "@/config";
import { isEmpty } from "@utils/formatters";
import type { SamplesFilters } from "../list/type";

async function getSamplesGeoJson(
  query?: SamplesFilters,
): Promise<SamplesGeoJsonResponse> {
  const params = new URLSearchParams();

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (isEmpty(value)) return;

      params.append(key, String(value));
    });
  }

  let url = apiPaths.samples.getGeoJson;

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<SamplesGeoJsonResponse>(url);

  return response.data;
}

export function useGetSamplesGeoJson(
  query?: SamplesFilters,
  options?: SWRConfiguration & { enabled?: boolean },
) {
  const enabled = options?.enabled ?? true;

  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    revalidateOnFocus: false,
    ...options,
  };

  return useSWR(
    enabled ? [`fetch-samples-geojson`, JSON.stringify(query ?? {})] : null,
    () => getSamplesGeoJson(query ?? {}),
    mergedOptions,
  );
}
